import _Object$getPrototypeOf from 'babel-runtime/core-js/object/get-prototype-of';
import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';
import React, { PureComponent } from 'react';
import { Transition } from 'react-transition-group';

import NestedNavigationPage from '../../styled/NestedNavigationPage';
import NestedNavigationWrapper from '../../styled/NestedNavigationWrapper';

var ContainerNavigationNested = function (_PureComponent) {
  _inherits(ContainerNavigationNested, _PureComponent);

  function ContainerNavigationNested() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ContainerNavigationNested);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ContainerNavigationNested.__proto__ || _Object$getPrototypeOf(ContainerNavigationNested)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      stack: _this.props.stack,
      traversalDirection: 'down'
    }, _this.handleAnimationEnd = function () {
      if (_this.props.onAnimationEnd) {
        _this.props.onAnimationEnd({
          traversalDirection: _this.state.traversalDirection
        });
      }
    }, _this.renderChildren = function () {
      return React.createElement(
        Transition,
        {
          addEndListener: function addEndListener(node, done) {
            node.addEventListener('animationend', done);
          },
          key: _this.state.stack.length,
          onExited: _this.handleAnimationEnd
        },
        function (transitionState) {
          return React.createElement(
            NestedNavigationPage,
            {
              transitionState: transitionState,
              traversalDirection: _this.state.traversalDirection
            },
            _this.state.stack[_this.state.stack.length - 1]
          );
        }
      );
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ContainerNavigationNested, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(_ref2) {
      var _this2 = this;

      var stack = _ref2.stack;

      var traversalDirection = function () {
        if (stack.length !== _this2.props.stack.length) {
          return stack.length < _this2.props.stack.length ? 'up' : 'down';
        }
        return _this2.state.traversalDirection;
      }();

      this.setState({ traversalDirection: traversalDirection }, function () {
        _this2.setState({ stack: stack });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return React.createElement(
        NestedNavigationWrapper,
        {
          component: 'div',
          traversalDirection: this.state.traversalDirection
        },
        this.renderChildren()
      );
    }
  }]);

  return ContainerNavigationNested;
}(PureComponent);

export default ContainerNavigationNested;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@atlaskit/navigation/dist/esm/components/js/nested/ContainerNavigationNested.js
// module id = 696
// module chunks = 0